import { Box, Typography } from '@mui/material'
import React, {
  useRef,
  useState,
  useCallback,
  useEffect,
  useContext
} from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import Webcam from 'react-webcam'
import FileContext from '../context/Context'
import axios from 'axios'
import CustomVideoToastify from '../camera-module/custom-notified-msg/CustomVideoToastify'
import VideoTimer from './video-timer/VideoTimer'
import { set_video_blob } from '../store/video_upload'
import { useDispatch } from 'react-redux'
import { ToastContainer, toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'

const VideoRecorder = () => {
  const [suggestion, setSuggestion] = useState('')
  const [perfectImage, setPerfectImage] = useState(false)
  const [showImage, setShowImage] = useState(false)
  const [videoCaptured, setVideoCaptured] = useState(false)
  const [btnType, setBtnType] = useState(true)
  const [textIntervalId, setTextIntervalId] = useState(null)
  const [toUpload, setToUpload] = useState(false)
  const [loadingCamera, setLoadingCamera] = useState(true)
  const [toastDisplayed, setToastDisplayed] = useState(false)
  const dispatch = useDispatch()
  const [activeDeviceId, setActiveDeviceId] = useState(null)
  const { claimNumber } = useParams()
  const [currentText, setCurrentText] = useState(0)
  const [timerValue, setTimerValue] = useState(301) // separate timer value

  const texts = [
    'Record the front windshield from Inside',
    'Record the front & back of the car’s RC',
    // 'Record all pages of the previous year policy',
    'Start the engine & record the total kilometers on the odometer',
    'Record the chassis number visible on the car body',
    // 'Record RC of the car',
    // 'Record the engine compartment under the front bonnet',
    'Record the front windshield from outside',
    'Record the front view of the car with the number plate',
    'Slowly move around the car to record it from all sides(360-degree view)'
  ]
  console.log(claimNumber, '22')
  const reload = `${process.env.PUBLIC_URL}/custom-icons/reload.png`
  const { capturedVideo, setCapturedVideo } = useContext(FileContext)
  const isIOS = () => {
    return (
      /iPhone|iPad|iPod/i.test(navigator.userAgent) ||
      (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)
    )
  }

  const captureAndAnalyze = useCallback(() => {
    if (webcamRef?.current && webcamRef.current?.getScreenshot()) {
      const imageSrc = webcamRef.current.getScreenshot()
      const image = new Image()
      image.src = imageSrc

      image.onload = () => {
        const canvas = document.createElement('canvas')
        const ctx = canvas.getContext('2d')
        canvas.width = image.width
        canvas.height = image.height
        ctx.drawImage(image, 0, 0, image.width, image.height)

        const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height)
        const lightingSuggestion = analyzeLighting(imageData)
        if (lightingSuggestion === 'Lighting looks good.') {
          setPerfectImage(true)
        } else {
          setPerfectImage(false)
        }
        setSuggestion(lightingSuggestion)
      }
    }
  }, [])
  const timerRef = useRef(301) // Ref to store elapsed time
  const intervalRef = useRef(null)

  const [windowDimensions, setWindowDimensions] = useState({
    width: window.innerWidth,
    height: window.innerHeight
  })
  const landscape = `${process.env.PUBLIC_URL}/inspection-icons/landscapeMode.svg`
  const navigate = useNavigate()

  const [isInLandscapeMode, setIsInLandscapeMode] = useState(
    window.screen.orientation.type
  )
  console.log('33', videoCaptured)
  useEffect(() => {
    if (
      isInLandscapeMode !== 'portrait-primary' &&
      isInLandscapeMode !== 'portrait-secondary'
    ) {
      const interval = setInterval(captureAndAnalyze, 500) // Analyze every 500ms
      return () => clearInterval(interval)
    }
  }, [captureAndAnalyze, isInLandscapeMode])

  useEffect(() => {
    const updateOrientation = () => {
      setIsInLandscapeMode(window.screen.orientation.type)
    }

    window.addEventListener('orientationchange', updateOrientation)

    return () => {
      window.removeEventListener('orientationchange', updateOrientation)
    }
  }, [isInLandscapeMode])
  console.log(isInLandscapeMode, '37')

  useEffect(() => {
    let timer
    if (videoCaptured) {
      timer = setTimeout(() => {
        navigate(`/processing/video/${claimNumber}`)
      }, 6000)
    }

    // Cleanup function to clear the timeout if the component unmounts or videoCaptured changes
    return () => clearTimeout(timer)
  }, [videoCaptured, navigate])

  useEffect(() => {
    const handleResize = () => {
      setWindowDimensions({
        width: window.innerWidth,
        height: window.innerHeight
      })
    }
    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  const webcamRef = useRef(null)
  const mediaRecorderRef = useRef(null)
  const [capturing, setCapturing] = useState(false)
  const [recordedChunks, setRecordedChunks] = useState([])

  const videoConstraints = {
    facingMode: 'environment',
    width: { ideal: 1920, max: 1920 },
    height: { ideal: 1080, max: 1080 },
    frameRate: { ideal: 30, max: 60 }, // Cap frame rate to 30fps for consistency
    audio: true
  }

  const recordedChunksRef = useRef([])

  const handleDataAvailable = useCallback(({ data }) => {
    console.log('Data available:', data)
    if (data.size > 0) {
      recordedChunksRef.current.push(data) // Store in the ref
      setRecordedChunks(prev => [...prev, data]) // Update state
      console.log('Recorded chunks updated:', recordedChunksRef.current)
      setCapturedVideo(recordedChunksRef.current)
    }
  }, [])
  const analyzeLighting = imageData => {
    //console.log(imageData, "9")
    const { data, width, height } = imageData
    let totalBrightness = 0

    for (let i = 0; i < data.length; i += 4) {
      const r = data[i]
      const g = data[i + 1]
      const b = data[i + 2]
      const brightness = (r + g + b) / 3
      totalBrightness += brightness
    }

    const averageBrightness = totalBrightness / (width * height)

    if (averageBrightness < 100) {
      return 'Increase lighting.'
    } else if (averageBrightness > 200) {
      return 'Reduce lighting.'
    } else {
      return 'Lighting looks good.'
    }
  }
  const getSupportedMimeType = () => {
    const mimeTypes = [
      'video/webm; codecs=vp9',
      'video/webm; codecs=vp8',
      'video/mp4', // Use MP4 for iOS
      'video/webm',
      'video/mp4; codecs=h264'
    ]
    return mimeTypes.find(type => MediaRecorder.isTypeSupported(type)) || ''
  }
  // const getSupportedMimeType = () => {
  //   const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent)

  //   if (isIOS && MediaRecorder.isTypeSupported('video/mp4')) {
  //     return 'video/mp4'
  //   }

  //   const types = [
  //     'video/webm;codecs=vp9',
  //     'video/webm;codecs=vp8',
  //     'video/webm'
  //   ]

  //   return types.find(t => MediaRecorder.isTypeSupported(t)) || ''
  // }

  const handleStartCaptureClick = useCallback(() => {
    const mimeType = getSupportedMimeType()
    const options = {
      mimeType: mimeType || 'video/webm',
      videoBitsPerSecond: 6000000, // 6 Mbps for video
      audioBitsPerSecond: 128000
    }
    setBtnType(!btnType)
    setCurrentText(0)
    const videoElement = webcamRef.current.video
    const stream = videoElement.srcObject
    // console.log("Actual frame rate:", videoElement.getVideoTracks()[0].getSettings().frameRate);

    setCapturing(true)

    clearInterval(intervalRef.current)
    timerRef.current = 301

    // mediaRecorderRef.current = new MediaRecorder(webcamRef.current.stream, options);
    mediaRecorderRef.current = new MediaRecorder(
      webcamRef.current.video.srcObject,
      options
    )
    mediaRecorderRef.current.addEventListener(
      'dataavailable',
      handleDataAvailable
    )
    intervalRef.current = setInterval(() => {
      if (timerRef.current > 0) {
        timerRef.current -= 1
        // setCurrentText(timerRef.current) // Update timer display
        setTimerValue(timerRef.current) // ✅ update separate timer state
      } else {
        handleStopCaptureClick() // Stop recording after the timer ends
      }
    }, 1000)

    mediaRecorderRef.current.start() // Record in smaller chunks
  }, [webcamRef, setCapturing, mediaRecorderRef, handleDataAvailable, btnType])

  useEffect(() => {
    if (btnType === false) {
      const interval = setInterval(() => {
        setCurrentText(prev => (prev + 1) % texts.length)
      }, 8000)

      setTextIntervalId(interval)

      return () => clearInterval(interval)
    }
  }, [btnType])
  const [res, setRes] = useState(null)
  // Function to get the highest camera resolution
  const getHighestResolution = async () => {
    try {
      // Access the user's video stream
      const stream = await navigator.mediaDevices.getUserMedia({
        video: { facingMode: 'environment' },
        audio: true
      })

      // Get the video track and its capabilities
      const videoTrack = stream.getVideoTracks()[0]
      const capabilities = videoTrack.getCapabilities()
      console.log('vT', videoTrack)

      // Get the max width and height from capabilities
      const maxWidth = capabilities.width?.max // Fallback to 1920 if unavailable
      const maxHeight = capabilities.height?.max // Fallback to 1080 if unavailable
      const maxFrameRate = capabilities.frameRate
        ? capabilities.frameRate.max
        : 30

      console.log(`Max resolution supported: ${maxWidth}x${maxHeight}`)
      setRes(`Max resolution supported: ${maxWidth}x${maxHeight}`)
      if ((maxWidth < 1920 || maxHeight < 1020) && !toastDisplayed) {
        toast.success('Low Resolution of Camera', {
          position: 'bottom-center',
          autoClose: 1000,
          type: 'default',
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: false,
          draggable: true,
          className: 'custom-toast'
        })
        setToastDisplayed(true) // Prevent the toast from showing multiple times
      }

      // Stop the video track to free up the camera
      videoTrack.stop()

      // Return the maximum resolution
      return { width: maxWidth, height: maxHeight, frameRate: maxFrameRate }
    } catch (error) {
      console.error('Error accessing camera capabilities:', error)
      return { width: 1920, height: 1080 } // Default resolution if error occurs
    }
  }

  useEffect(() => {
    const setupCamera = async () => {
      const resolution = await getHighestResolution()
    }

    setupCamera()
  }, [])
  const handleRetake = () => {
    setVideoCaptured(false)
    setRecordedChunks([])
    mediaRecorderRef.current = null // Reset the MediaRecorder

    // Check if webcamRef and video element are defined
    if (webcamRef.current && webcamRef.current.video) {
      const videoElement = webcamRef.current.video
      if (videoElement.srcObject) {
        videoElement.srcObject.getTracks().forEach(track => track.stop()) // Stop the previous webcam stream
      }
    } else {
      console.error('Webcam ref or video element is null.')
    }

    // Reinitialize the webcam (or let React do this automatically if using `Webcam` component properly)
    setTimeout(() => {
      setCapturedVideo(null) // Reset captured video state
    }, 1000) // Delay to ensure cleanup is done
  }
  const formatTime = seconds => {
    const minutes = Math.floor(seconds / 60)
    const remainingSeconds = seconds % 60
    return `${minutes < 10 ? '0' : ''}${minutes}:${
      remainingSeconds < 10 ? '0' : ''
    }${remainingSeconds}`
  }

  useEffect(() => {
    if (timerRef.current <= 0) {
      handleStopCaptureClick() // Stop capture when timer hits 0
    }
  }, [capturing]) // Listen for changes in capturing state

  const handleStopCaptureClick = useCallback(async () => {
    setBtnType(!btnType)
    setVideoCaptured(!videoCaptured)
    console.log('stop')

    mediaRecorderRef.current.stop()
    setCapturing(false)
    clearInterval(intervalRef.current)
    timerRef.current = 301
    console.log(recordedChunks, '183')
    clearInterval(textIntervalId) // Stop the text updates
    setTextIntervalId(null)

    // Capture the current timestamp and location coordinates
    const clicked_time = new Date().toISOString()
    let longitude = null
    let latitude = null
    // Use Geolocation API to get location coordinates
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        position => {
          longitude = position.coords.longitude
          latitude = position.coords.latitude

          // Prepare data to send to backend
          const data = {
            claimNumber: claimNumber, // Replace with your claimNumber variable
            clicked_time,
            longitude,
            latitude
          }

          // Send the data to the backend
          axios
            .post(`/process_data/updateVideoDetails/${claimNumber}`, {
              clicked_time,
              longitude,
              latitude
            })
            .then(response => {
              console.log('Database updated successfully:', response.data)
            })
            .catch(error => {
              console.error('Error updating the database:', error)
            })
        },
        error => {
          console.error('Error getting location:', error)
        }
      )
    } else {
      console.warn('Geolocation is not supported by this browser.')
    }
  }, [btnType])

  console.log('timer', timerRef.current)

  const buttonStyle = {
    display: 'flex',
    cursor: 'pointer',
    alignItems: 'center',
    justifyContent: 'center',
    width: '72px',
    height: '72px',
    backgroundColor: 'transparent',
    borderRadius: '50%',
    border: perfectImage ? '4px solid green' : '4px solid white',
    padding: '1px' // gap
  }

  const innerCircleStyle = {
    width: '55px',
    height: '55px',
    borderRadius: '50%'
  }
  console.log(showImage, '172')

  const handleDevices = React.useCallback(mediaDevices => {
    const videoInputs = mediaDevices.filter(
      device => device.kind === 'videoinput'
    )

    // Try to pick the Samsung "camera2 0, facing back" if available
    const samsungBackCam = videoInputs.find(device =>
      device.label.toLowerCase().includes('0')
    )

    // If on Samsung and we found the preferred back cam, use that
    if (samsungBackCam) {
      setActiveDeviceId(samsungBackCam.deviceId)
    } else {
      // Otherwise, fallback to any "facing back" cam
      const genericBackCam = videoInputs.find(device =>
        device.label.toLowerCase().includes('facing back')
      )
      setActiveDeviceId(null)
    }
  }, [])
  useEffect(() => {
    navigator.mediaDevices.enumerateDevices().then(handleDevices)
  }, [handleDevices])

  const videoConstraintsRef = useRef({
    width: 1920,
    height: 1080,
    deviceId: activeDeviceId,
    facingMode: 'environment'
  })
  useEffect(() => {
    videoConstraintsRef.current = {
      width: 1920,
      height: 1080,
      deviceId: activeDeviceId ? activeDeviceId : null,
      facingMode: 'environment'
    }
  }, [activeDeviceId])

  return (
    <>
      {isInLandscapeMode === 'portrait-primary' ||
      isInLandscapeMode === 'portrait-secondary' ? (
        <div
          style={{
            // backgroundColor: "#427eea",
            opacity: '0.8',
            height: '100svh',
            width: '100%',
            display: 'flex',
            alignItems: 'center',
            flexDirection: 'column',
            justifyContent: 'center'
          }}
        >
          <div
            style={{
              height: '9rem',
              width: '9rem',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              backgroundColor: '#F2F2F7',
              borderRadius: '50%'
            }}
          >
            <img
              src={landscape}
              alt='Landscape GIF'
              style={{
                height: '4rem'
                // animation: "tiltDown 1s ease infinite alternate",
              }}
            />
          </div>
          <h3
            style={{
              // color: "#fff",
              textAlign: 'center',
              marginBottom: '0.5rem',
              wordWrap: 'break-word'
            }}
          >
            Please rotate video to landscape
          </h3>
          <h6
            style={{
              // color: "#fff",
              padding: '0 1rem',
              textAlign: 'center',
              wordWrap: 'break-word'
            }}
          >
            Turn on auto-rotation as video needs to be captured in landscape
            mode.
          </h6>
        </div>
      ) : videoCaptured ? (
        <div
          style={{
            width: '100vw',
            height: '100svh',
            overflow: 'hidden',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: 'black'
          }}
        >
          <div
            style={{
              position: 'absolute',
              top: '60%',
              // // right: "1.5rem",
              transform: 'translateY(-50%)',
              display: 'flex',
              flexDirection: 'column',
              alignContent: 'center',
              justifyContent: 'center',
              gap: '6rem'

              // bottom: "20px"
            }}
          >
            <CustomVideoToastify />
            <button
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '0.2rem',
                border: '1.5px solid #FF0083',
                padding: '0rem 1.2rem',
                backgroundColor: 'white',
                borderRadius: '5px',
                opacity: '0.9'
              }}
            >
              <img src={reload} style={{ width: '1rem', height: '1rem' }}></img>
              <p
                style={{
                  fontSize: '1rem',
                  fontFamily: "'Montserrat', sans-serif",
                  color: '#FF0083',
                  padding: '0.5rem',
                  cursor: 'pointer'
                }}
                onClick={handleRetake}
              >
                Retake
              </p>
            </button>
          </div>
        </div>
      ) : (
        <>
          {toastDisplayed && <ToastContainer />}
          <Typography
            sx={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
              padding: '8px 8px',
              gap: '10px',
              position: 'absolute',
              width: 'auto',
              height: '33px',
              left: '15px',
              top: '24px',
              background: 'rgba(255, 255, 255, 0.7)',
              borderRadius: '8px',
              fontFamily: "'Montserrat', sans-serif",
              fontStyle: 'normal',
              fontWeight: 500,
              fontSize: '14px',
              lineHeight: '157%',
              textAlign: 'center',
              letterSpacing: '0.1px',
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              color: 'black',
              zIndex: 100,
              '@media (max-width: 900px)and (orientation: landscape)': {
                // fontSize: '12px'
                fontSize: '14px',
                fontWeight: 800,
                color: 'black'
              }
            }}
          >
            {!btnType ? texts[currentText] : 'Press Start to begin recording'}
          </Typography>

          {suggestion && !videoCaptured && (
            <Typography
              sx={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                padding: '8px 8px',
                gap: '10px',
                position: 'absolute',
                width: 'auto',
                height: '33px',
                left: '15px',
                bottom: '30px',
                background: 'rgba(255, 255, 255, 0.6)',
                borderRadius: '8px',
                fontFamily: "'Montserrat', sans-serif",
                fontStyle: 'normal',
                fontWeight: 500,
                fontSize: '13px',
                lineHeight: '157%',
                textAlign: 'center',
                letterSpacing: '0.1px',
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                color: 'black',
                zIndex: 100,
                '@media (max-width: 900px)and (orientation: landscape)': {
                  fontSize: '12px'
                }
              }}
            >
              {suggestion}
            </Typography>
          )}

          <div
            className='image-page'
            style={{
              display: 'flex',
              flexDirection: 'row',
              width: windowDimensions.width, //"100%",
              height: windowDimensions.height, //"100svh",
              display: 'flex'
              // display: videoCaptured ? "none" : "flex"
              // position: "relative",
            }}
            // ref={containerRef}
          >
            <div
              className='webcam-container'
              style={{
                width: '100vw',
                height: '100svh',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                backgroundColor: 'black',
                overflow: 'hidden',
                position: 'relative'
              }}
            >
              <Webcam
                ref={webcamRef}
                audio={true}
                muted={true}
                videoConstraints={videoConstraintsRef.current}
                height='100%'
                width='100%'
                className='webcam'
                style={{
                  position: 'absolute',
                  textAlign: 'center',
                  zIndex: 8,
                  right: 0,
                  objectFit: 'cover',
                  overflow: 'hidden'
                }}
              />
              <div></div>
            </div>
            <div
              style={{
                position: 'absolute',
                right: '50%',
                top: '50%',
                transform: 'translate(50%, -50%)',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                padding: '0.5rem 1rem',
                zIndex: 2000,
                color: 'white',
                fontSize: '1.5rem',
                borderRadius: '50%'
              }}
            >
              {timerRef.current - 1 <= 5 && (
                <VideoTimer number={timerRef.current - 1} />
              )}
            </div>
            {!btnType && (
              <Typography
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  alignItems: 'center',
                  padding: '8px 8px',
                  gap: '10px',
                  position: 'absolute',
                  width: 'auto',
                  height: '33px',
                  right: '15px',
                  top: '24px',
                  background: 'rgba(255, 255, 255, 0.6)',
                  borderRadius: '8px',
                  fontFamily: "'Montserrat', sans-serif",
                  fontStyle: 'normal',
                  fontWeight: 500,
                  fontSize: '14px',
                  lineHeight: '157%',
                  textAlign: 'center',
                  letterSpacing: '0.1px',
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  color: 'black',
                  zIndex: 100,
                  '@media (max-width: 900px)and (orientation: landscape)': {
                    fontSize: '12px'
                  }
                }}
              >
                {formatTime(timerRef.current - 1)}
              </Typography>
            )}
            <div
              style={{
                position: 'absolute',
                right: '1.5rem',
                height: '100svh',
                display: 'flex',
                justifyContent: 'flex-end',
                flexDirection: 'column',
                gap: '1rem',
                top: '44px',
                zIndex: 2000
              }}
            >
              {/* <p></p> */}
              <div
                style={{
                  // position: "relative",
                  // bottom: "60px",
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  height: '100svh'
                }}
              >
                <div
                  style={buttonStyle}
                  onClick={
                    btnType ? handleStartCaptureClick : handleStopCaptureClick
                  }
                >
                  <div
                    style={{
                      ...innerCircleStyle,
                      backgroundColor: btnType ? 'green' : '#F44336'
                    }}
                  ></div>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  )
}

export default VideoRecorder
